export const DATE_FORMAT_LONG = 'DD MMMM YYYY';
export const LANG_KEY = '_lang';
export const CARD_LIMIT = 10;
export const GAME_LIMIT = 30;
